module.exports = __webpack_public_path__ + "media/images/community_stories/community-ec29fb224ac72ce65c4100ecd779fb80.jpg";